import { Shield } from "lucide-react";
import { SecurityIcon } from "./security-icon";
import { type Locale, getTranslationFn } from "../../i18n";

interface SecuritySectionProps {
  locale: Locale;
}

export function SecuritySection({ locale }: SecuritySectionProps) {
  const t = getTranslationFn(locale);

  const securityFeatures = [
    t("Landing.security.encryption"),
    t("Landing.security.isolation"),
    t("Landing.security.zeroTraining"),
    t("Landing.security.privateCloud"),
  ];

  return (
    <section
      id="security"
      className="py-24 bg-[rgb(28,28,28)] text-white relative"
    >
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight">
              {t("Landing.security.title")}
            </h2>
            <p className="text-slate-400 text-lg leading-relaxed">
              {t("Landing.security.description")}
            </p>
            <ul className="space-y-4">
              {securityFeatures.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <Shield className="h-6 w-6 text-slate-400 shrink-0" />
                  <span className="text-slate-300">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="relative">
            <div className="bg-[rgb(28,28,28)]/50 border border-slate-700/50 p-8 backdrop-blur-xl">
              <div className="flex items-center justify-center mb-8">
                <SecurityIcon className="h-16 w-16 text-slate-200" />
              </div>
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 border border-slate-800 bg-slate-900/50">
                  <span className="text-sm font-medium text-slate-400">
                    {t("Landing.security.encryptionLabel")}
                  </span>
                  <span className="text-sm font-medium text-slate-200 flex items-center gap-2">
                    <Shield className="h-3 w-3 text-emerald-500" />
                    AES-256
                  </span>
                </div>
                <div className="flex justify-between items-center p-4 border border-slate-800 bg-slate-900/50">
                  <span className="text-sm font-medium text-slate-400">
                    {t("Landing.security.dataResidency")}
                  </span>
                  <span className="text-sm font-medium text-slate-200">
                    {t("Landing.security.dataResidencyValue")}
                  </span>
                </div>
                <div className="flex justify-between items-center p-4 border border-slate-800 bg-slate-900/50">
                  <span className="text-sm font-medium text-slate-400">
                    {t("Landing.security.auditTrailLabel")}
                  </span>
                  <span className="text-sm font-medium text-slate-200">
                    {t("Landing.security.auditTrailValue")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
